<div [matTooltip]="tooltip" [matTooltipDisabled]="isInOverflowMenu">
    <button
        [attr.automation-id]="automationId"
        [type]="buttonType"
        class="p-action-btn"
        [ngClass]="{ 'menu-trigger': isMenuTrigger, active: isActive, standalone: isStandalone }"
        [disabled]="disabled"
        (click)="onClick($event)"
        (blur)="isActive = false"
    >
        <p-icon
            *ngIf="iconBeforeName"
            class="p-action-btn-icon"
            [name]="iconBeforeName"
            [size]="iconBeforeSize"
            [color]="iconBeforeColor"
            [disabled]="disabled"
        ></p-icon>
        <p-icon-image *ngIf="imageBeforeName" class="p-action-btn-icon" [name]="imageBeforeName" [size]="iconBeforeSize"></p-icon-image>
        <span *ngIf="label" class="p-action-btn-label">{{ isSentenceCase ? (label | sentenceCase) : label }}</span>
        <p-icon *ngIf="isMenuTrigger && !isRight" class="p-action-btn-arrow" name="chevron-down" [disabled]="disabled"></p-icon>
        <p-icon *ngIf="isMenuTrigger && isRight" class="p-action-btn-arrow-right" name="chevron-right" [disabled]="disabled"></p-icon>
    </button>
</div>
